<template lang="pug">
    div(id="friendslocconfig")
        p Online friends:
        v-switch(v-model="do_share_position" label="Share localization")
        v-text-field(v-model="userName" dense label="Name")
        v-list(dense)
            v-list-item(id="friendlist" v-for="(friend, _id, i) in friends"
                        :key="friend.color"
                        style="padding: 0px")
                v-container(fluid style="padding: 0px")
                    v-row(dense)
                        v-col(cols=9)
                            v-text-field(@click="onFriendClicked(friend.id)" :value="friend.data.user_name" readonly)
                                template(v-slot:append)
                                    span()
                                        svg(xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24" :fill="friend.data.color")
                                            path(d="M0 0h24v24H0z" fill="none")
                                            path(d="M15.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM5 12c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5zm5.8-10l2.4-2.4.8.8c1.3 1.3 3 2.1 5.1 2.1V9c-1.5 0-2.7-.6-3.6-1.5l-1.9-1.9c-.5-.4-1-.6-1.6-.6s-1.1.2-1.4.6L7.8 8.4c-.4.4-.6.9-.6 1.4 0 .6.2 1.1.6 1.4L11 14v5h2v-6.2l-2.2-2.3zM19 12c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5z")    
                        v-col()
                            p {{friend.delta_time}}
</template>


<script>
import { app_state, OnLiveLocalizationChanged } from './../js/app_state'
import { APIFriendsLocalization } from './../js/api_friends_localization'
import { bus } from '../main.js'
import { getPrettyTime } from '../js/utils'

export default {
    data: () => ({
        do_share_position: false,
        friends: [],
    }),

    mounted() {
        // subscribe to live localization parameter that is required to share live position:
        OnLiveLocalizationChanged.push(() => { this.onLiveLocalizationChanged(); });
        APIFriendsLocalization.OnStateChanged.push((state) => { this.onFriendsLocAPIStateChanged(state); });
        APIFriendsLocalization.OnNewFriend.push(() => { this.onNewFriend(); });
        APIFriendsLocalization.OnLostFriend.push(() => { this.onLostFriend(); });
        APIFriendsLocalization.OnLocationUpdated.push((friends) => { this.onLocationUpdated(friends); });
    },

    methods: {
        onLiveLocalizationChanged() {
            if (this.do_share_position && !app_state.live_localization) {
                this.do_share_position = false;
            }
        },

        onFriendsLocAPIStateChanged(state) {
            this.do_share_position = state;
            this.friends = [];
        },

        onNewFriend() {
            let ret = [];
            for (const friend of APIFriendsLocalization.friends) {
                ret.push({id: friend[0], data:friend[1], delta_time: 0});
            }
            this.friends = ret;
        },

        onLostFriend() {
            let ret = [];
            for (const friend of APIFriendsLocalization.friends) {
                ret.push({id: friend[0], data:friend[1], delta_time: 0});
            }
            this.friends = ret;
        },

         onLocationUpdated(friends) {
             for (let [key, f_value] of friends.entries()) {
                 const dtime = getPrettyTime(f_value.delta_ts / 1000);  // ms to sec
                 let friend = this.friends.find(el => el.id === key)
                 friend.delta_time = dtime;
             }
             this.$forceUpdate();
         },

        onFriendClicked(_id) {
            bus.$emit('zoomFriend', _id);
        }
    },

    computed: {
        userName: {
            get() {
                return APIFriendsLocalization.user_name;
            },

            set(new_value) {
                APIFriendsLocalization.setName(new_value);
            }
        },
    },

    watch: {
        do_share_position(new_val) {
            if (new_val) {
                APIFriendsLocalization.enable();
            } else {
                APIFriendsLocalization.disable();
            }
        },
    }
}
</script>

<style scoped>
#friendslocconfig {
    margin-top: 10px;
    margin-left: 10px;
    margin-right: 10px;
};
</style>